/**
 * SearchAZ, subclass of SearchInterface
 * requires backbone.js
 */

var SearchAZ = SearchInterface.extend({
	/** @lends SearchAZ.prototype */

	/**
	 * Set the interface's config options
	 * @param {Object} config
	 * @param {Int} config.site_id LG site id
	 * @param {Bool} config.display_facets are we displaying facet limiters
	 * @param {Object} config.facets facet limiters for current search
	 * @param {Object} config.sort sorting for current search
	 * @param {Object[]} config.sort_options options for sorting the results
	 * @param {String} config.sort_options[].field name of sorting field
	 * @param {String} config.sort_options[].dir direction of sort (asc/desc)
	 * @param {String} config.sort_options[].label human readable name of sorting field
	 * @param {Object} [config.query_facet_results] facets data returned for current search
	 * @param {Object} config.searchwt weight for various search fields
	 * @param {String} config.alphaLetter Single letter to browse source names
	 */
	setConfig: function(config) {
		var defaults = {
			site_id: 0,
			display_facets: true,
			facets: {
				subjects: [],
				types: [],
				vendor: [],
				_n: []
			},
			perpage: 50,
			sort: { field: 'n', dir: 'asc' },
			sort_options: [
				//{ field: 'score', dir: 'desc', label: this.get('lang').srch_sortlabelrel },
				//{ field: 'n', dir: 'asc', label: this.get('lang').srch_sortlabelalpha }
			],
			query_facet_results: {},
			searchwt: { subjects: 8, n: 8, d: 3, best_bets: 9, allInOne: 1 },
			alphaLetter: ''
		};

		_.extend(defaults, config);
		_.each(defaults, function(v,k,l){
			this.set(k, v, { silent: true });
		}, this);

		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });
	},
	/**
	 * Render the views
	 */
	renderViews: function() {
		var $container = jQuery(this.get('selector'));
		var views = []; //array of rows with views in them

		//var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		var params = new AZCurrentParamsView({ model: this, id: 's-srch-params-'+this.get('id') });

		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });

		var resultslist = new AZResultsList({ model: this, id: 's-srch-results-'+this.get('id') });

		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}

		views.push( jQuery('<div class="row"></div>').append(['<div class="col-sm-6"></div>', top_pagination.$el]) );
		views.push( jQuery('<div class="row"></div>').append(params.$el) );
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );

		if (this.get('display_facets') === true) {
			// lg2 local searching
			if (typeof searchLg2Az !== 'undefined') {
				var $col1 = jQuery('<div class="col-md-9 col-left"></div>').append(views);
				var $col2 = jQuery('<div class="col-md-3 col-right"></div>');
				$container.append( jQuery('<div class="row"></div>').append([$col1, $col2]) );
			}
			// api (la) searching
			else {
				var $col1 = jQuery('<div class="col-md-12"></div>').append(views);
				var $col2 = jQuery('<div class="col-md-12"></div>');

				//facet views
				var facetviews = [];
				_.each(this.get('facets'), function(v,k,l){
					if (k == '_n') {
						facetviews.push( new AZBrowseView({ model: this, facetType: k }) );
					} else {
						facetviews.push( new AZFacetView({ model: this, id: 's-srch-facet-'+this.get('id')+'-'+k, facetType: k }) );
					}
				}, this);
				_.each(facetviews, function(v,k){
					$col2.append(v.$el);
				}, this);
				$container.append( jQuery('<div class="row"></div>').append([$col2, $col1]) );
			}
		} else {
			$container.append( views );
		}
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		if (typeof autocomp == 'undefined') {
			autocomp = false;
		}

		qo = {
			search_source_id: this.get('id'),
			rows: this.get('perpage'),
		};

		//facets
		var facets = {};
		facets = this.get('facets');
		qo['facet.limit'] = 100;

		//site param
		qo['fq'] = [];
		qo['fq'].push('s:'+this.get('site_id'));

		var page = this.get('page');
		qo.start = (qo.rows * (page - 1));

		//we skip some stuff for autocomplete
		if (!autocomp) {
			_.each(facets, function(v,k,l){
				var facet_query = '';
				var facetquery = '';
				if (k == '_n') {
					if (v.length > 0) {
						if (v[0] == '#') {
							qo['fq'].push('-_n:/[a-z]/i');
						} else {
							qo['fq'].push('_n:'+v[0]);
						}
					}
				}

				else if (v.length > 0) {
					_.each(v, function(vx,kx,lx){
						facetquery += '"'+vx+'"';
						if (kx !== lx.length - 1) {
							facetquery += ' OR ';
						}
					}, this);
					facet_query = k+':('+facetquery+')';
					qo['fq'].push(facet_query);
				}

			}, this);

			qo.q = this.convertSearch();
			//user alpha for browse and relevancy for search
			if (qo.q == '*:*') {
				this.set('sort', { field: 'n', dir: 'asc' });
			} else {
				this.set('sort', { field: 'score', dir: 'desc' });
			}

			s = this.get('sort');
			qo.sort = s.field+' '+s.dir;

			this.set('query_obj', qo);
		} else {
			qo.facet = false;
			return qo;
		}

	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * @return {string}
	 */
	convertSearch: function() {
		//maybe we need to escape (with a backslash \ ) some characters: + - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
		var typed = this.get('query_typed');
		return typed;
	},
	/**
	 * Request the data (an ajax request)
	 * Fires a bunch of events on success
	 * return {null}
	 */
	requestData: function() {
		// if the request was coming from a LG2 site, call the local search function which returns fully rendered HTML
		if (typeof searchLg2Az !== 'undefined') {
			searchLg2Az(this.get('id'));
		}
		// else, the request is coming from another app (LA) so we make the API based search call which returns JSON formatted data
		else {
			var self = this;

			workingAlert();

			$.ajax({
			  url: this.protocol+'//'+this.get('request_url'),
			  data: this.get('query_obj'),
			  success: function(d, status){
				  clearTimeout(requestError);
				  self.cacheResults(d);
				  self.parseResults(d);
				  self.setFocus();
				  stopAlert();
			  },
			  traditional: true, //this lets the query have multiple parameters that don't use the [] syntax (cause solr wants that)
			  dataType: 'jsonp',
			  jsonp: 'json.wrf'
			});

			var requestError = setTimeout(function() {
			   // Handle error accordingly
			   errorAlert();
			}, 10000);
		}

        //track stats in LG; TODO replace the hardcoded 27 with a reference to StatsConst::TRACKING_TYPE_SEARCH_AZ?
		if (typeof springSpace.springTrack !== 'undefined') {
			try {
				if (this.get('query_typed') == '' || this.get('query_typed') == '*:*') { return; }
				springSpace.springTrack.trackSearch({ _st_type_id: '27', _st_group_id: 0, _st_guide_id: 0, _st_search_terms: this.get('query_typed') });
			}
			catch(e) {
				searchcontroller.debug(e);
			}
		}

	},
	/**
	 * Apply facet data retrieved from Solr
	 */
	parseFacets: function(data) {
		// only run for API based searches; local LG searches will process facets in searchLg2Local()
		if (typeof searchLg2Az !== 'undefined') {
			return;
		}
		searchcontroller.debug(this.get('id')+' parseFacets');

		//integrate best_bets into subjects
		if (data.facet_counts.facet_fields && data.facet_counts.facet_fields.best_bets) {
			var best_bets = data.facet_counts.facet_fields.best_bets;
			delete data.facet_counts.facet_fields.best_bets;
			if (!data.facet_counts.facet_fields.subjects) {
				data.facet_counts.facet_fields.subjects = {};
			}

			_.each(best_bets, function(v,k){
				if (data.facet_counts.facet_fields.subjects[k]) {
					data.facet_counts.facet_fields.subjects[k] = data.facet_counts.facet_fields.subjects[k] + v;
				} else {
					data.facet_counts.facet_fields.subjects[k] = v;
				}
			}, this);
		}

		//convert _n to first letter
		if (data.facet_counts.facet_fields && data.facet_counts.facet_fields._n) {
			var names = data.facet_counts.facet_fields._n;
			data.facet_counts.facet_fields._n = {};
			_.each(names, function(v,k){
				//var letter = k.substr(0, 1);
				if (!data.facet_counts.facet_fields._n[k]) {
					if (k.match(/[a-z]/i) == null) {
						k = '#';
					}
					data.facet_counts.facet_fields._n[k] = 1;
				}
			}, this);
		}

		this.set('facet_results', data.facet_counts.facet_fields);
		this.trigger('facets:retrieve');
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from solr query
	 */
	parseResults: function(data) {
		this.set({
			'results': data.response.docs,
			'total_results': data.response.numFound,
			'query_facet_results': data.facet_counts.facet_fields
		});

		if (this.get('display_facets')) {
			//this.retrieveFacets(); //Use the facets from the results set directly
			this.parseFacets(data);
		}

		if (data.response.numFound == 0) {
			this.trigger('search:noresults');
		} else {
			this.trigger('search:retrieve');
		}

	}

});


//!AZResultsList View
var AZResultsList = ResultsList.extend(
/** @lends AZResultsList.prototype */
{

	events: {
		'click .s-srch-showqform': 'showQForm',
		'click .s-srch-result-subj a': 'setFacet',
		'click .s-srch-result-title a': 'trackClick',
	},
	/**
	 * render the results
	 */
    render: function () {
	    var subject_facet = this.model.get('facets')['subjects'];
	    this.cur_subj = (subject_facet.length > 0) ? subject_facet[0].toLowerCase() : '';

    	var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
    	var $features_list = $('<ul class="list-unstyled"></ul>');
		var results = this.model.get('results');
		var include_featured = false;
		if(results.length > 0) {
			_.each(results, function(v,k,l){
				var $li = this.resultItem(v);
				if ($li.hasClass('s-srch-result-featured')) {
					$features_list.append($li);
					include_featured = true;
				} else {
					$list.append($li);
				}
			}, this);
		}

		if (include_featured) {
			$list.prepend( $('<li></li>').addClass('s-srch-results-featured').append([$('<h3></h3>').html( this.model.get('lang').az_bestbets_heading ), $features_list]) );
		}

		this.$el.html($list);
		return this;
    },
	/**
     * When no results are retrieved empty results list. No results alert/form will appear.
     */
    noResults: function() {
    	$(this.el).html('');
    	return this;
    },
	/**
	 * Show the result
	 * @param {Object} item result object
	 * @param {Int} item.g group id
	 * @param {Int} item.id faq id
	 * @param {Array} item.keywords the keywords
	 * @param {Array} item.topics topic names only
	 * @param {String} item.question
	 * @param {String} item.updated last updated date
	 * @param {Int} item.s LA iid
	 * @return {Object} jQuery object
	 */
	resultItem: function(item) {
		var $li = $('<li></li>').addClass('s-srch-result');

		if (!item.id) { return ''; }

		item.subjects = (item.subjects) ? item.subjects : [];

        // If the site_url is zero-length consider it a relative URL.
		item.url = ( this.model.get('site_url') == '' ? '/' : '//' + this.model.get('site_url') + '/' ) + 'go.php?c='+item.id;

		/*
		id type="integer" -> ID
		s type="integer" -> SITE ID
		n type="u_text" -> Name
		_n type = ??? -> First Letter of Name
		d type="text" -> Description
		m type="text" -> more info currently empty???
		types type="u_text"
		subjects type="u_text"
		best_bets type="u_text"
		created type="date" ->
		updated type="date" ->
		owner type="u_text"
		vendor type="u_text" ->
		slug type="u_text"
		trial type="boolean" -> trial flag
		new" type="boolean" -> new flag
		*/

		if (!item.n) { item.n = ''; }
		if (!item.d) { item.d = ''; }

		//Figure out if it's a "best bet" for the current subject
		item.isbest = false;
		if (this.cur_subj !== '' && item.best_bets && item.best_bets.length > 0 && Array.prototype.some) {
			var index = -1;
			item.best_bets.some(function(element, i) {
			    if (this.cur_subj === element.toLowerCase()) {
			        index = i;
			        return true;
			    }
			}, this);
			if (index !== -1) {
				item.isbest = true;
			}
		}
		if (item.isbest) {
			$li.addClass('s-srch-result-featured');
		}


		//add best bets to subject array
		if (item.best_bets && item.best_bets.length > 0) {
			item.subjects = _.union(item.best_bets, item.subjects);
		}

		item.isnew = item['new'];

		if (this.model.get('item_template') === '') {
			if (searchcontroller.get('layout') == 'bento') {
				this.model.set('item_template',
					'<div class=s-srch-result-title>'+
						'<a href="{{ url }}" data-id={{ id }}>{{ n }}</a>'+
						'{{# if (isbest) { }} <span class="badge-featurd label label-success">'+this.model.get('lang').az_bestbets_label+'</span>{{# } }}'+
						'{{# if (isnew) { }} <span class="badge-new label label-info">'+this.model.get('lang').az_new_label+'</span>{{# } }}'+
						'{{# if (trial) { }} <span class="badge-trial label label-warning">'+this.model.get('lang').az_trial_label+'</span>{{# } }}'+
					'</div>'+
					'<div class="s-srch-result-meta">'+
						'{{# if (d !== \'\') { }}<p>{{ d }}</p>{{# } }}'+
						'{{# if (subjects.length > 0) { }}'+
							'<span class="s-srch-result-subj">'+
								'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
								'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
									'{{# _.each(subjects, function(v,k){ }}'+
									'<li>{{v}}'+
									'{{# if (k+1 < subjects.length){ print(\';\'); } }}'+
									'</li>'+
								'{{# }); }}'+
								'</ul>'+
							'</span>'+
						'{{# } }}'+
					'</div>'
					,
				{ silent: true });
			} else {
				this.model.set('item_template',
					'<div class=s-srch-result-title>'+
						'<a href="{{ url }}" data-id={{ id }}>{{ n }}</a>'+
						'{{# if (isbest) { }} <span class="badge-featurd label label-success">'+this.model.get('lang').az_bestbets_label+'</span>{{# } }}'+
						'{{# if (isnew) { }} <span class="badge-new label label-info">'+this.model.get('lang').az_new_label+'</span>{{# } }}'+
						'{{# if (trial) { }} <span class="badge-trial label label-warning">'+this.model.get('lang').az_trial_label+'</span>{{# } }}'+
					'</div>'+
					'<div class="s-srch-result-meta">'+
						'{{# if (d !== \'\') { }}<p>{{ d }}</p>{{# } }}'+
						'{{# if (subjects.length > 0) { }}'+
							'<span class="s-srch-result-subj">'+
								'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
								'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
									'{{# _.each(subjects, function(v){ }}'+
										'<li><span class="label label-default"><a href="#" data-subject="{{{ v }}}">{{ v }}</a></span></li>'+
									'{{# }); }}'+
								'</ul>'+
							'</span>'+
						'{{# } }}'+
					'</div>'
					,
				{ silent: true });

			}
		}

		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}

		try {
			html = this.item_template(item);
		} catch(e) {
			searchcontroller.debug(e);
			return '';
		}
		return $li.html( html );
	},
	/**
	 * Clicking on a result title updates stats
	 */
	trackClick: function(e) {
		if (typeof springTrack !== 'undefined') {
			var id = jQuery(e.currentTarget).attr('data-id');
			try {
				springTrack.trackLink({ link: e.currentTarget, _st_type_id: '16', _st_content_id: id });
			} catch(e) {
				searchcontroller.debug(e);
			}
		}
		return true;
	},
	/**
	 * Clicking on a subjects in the results sets that subjects as the only facet filter
	 */
	setFacet: function(e) {
		e.preventDefault();
		var subject = $(e.currentTarget).attr('data-subject').toLowerCase();
		this.model.setFacet('subjects', subject);
	}
});

//!AZCurrentParamsView
var AZCurrentParamsView = CurrentParamsView.extend(
/** @lends AZCurrentParamsView.prototype */
{
	/**
	 * create the display
	 */
	render: function() {

		this.$el.html('');
		var $container = jQuery('<div></div>').addClass('s-srch-params s-srch-params-az').attr({ 'aria-live': 'polite', 'aria-relevant': 'text' });

		var facetData = this.model.get('facets');

		var links = [];

		//So we dont show the current search and clear button on bento
		if (searchcontroller.get('layout') !== 'bento') {
			//iterate the facet types
			_.each(facetData, function(f, t){
				if (f.length > 0) {
					//iterate the values on the specific facet
					$li = $('<li></li>');
					var html = ' ';
					_.each(f, function(v,k,l) {
						var f_value = v.capitalize();
						if (f_value.indexOf(' ') !== -1) {
							html += '"'+f_value+'"';
						} else {
							html += f_value;
						}

						if (l.length > (k + 1)) {
				    	 	html += ' OR ';
			    	    }
					}, this);

					if (f.length > 1) {
						html = '('+html+')';
					}
					html += ';'

					var $filterNames = $('<span></span>').text(html);
        			$li.append($filterNames);

					links.push($li);
				}
			}, this);

			if (this.model.get('query_typed') !== '') {
				$li = $('<li></li>');
				var $span = $('<span></span>').text(' ' + this.model.get('query_typed') + ';');
				$li.append($span);
				links.push($li);
			}
		}

		//add a remove all link if appropriate
		if (links.length > 0) {
			$li = $('<li></li>').append(
		    	        $('<a href="#" class="removeAll" aria-controls="s-srch-results-'+this.model.get('id')+'"></a>')
		    	        .html('<i class="fa fa-times-circle"></i> '+this.model.get('lang').az_clear_filters)
		    	    );
			links.push($li);
		}

		var total = this.model.get('total_results');
		var perPage = this.model.get('perpage');
		var offset = (this.model.get('page') - 1) * perPage;

		this.$rangeHeader = $('<span></span>').text(springSpace.Util.stringFormat(this.model.get('lang').srch_resrange, [Math.min(total, offset + 1) + ' - ' + Math.min(total, offset + perPage), total]) + ' '+this.model.get('lang').az_database_plural);

		if (links.length > 0) {
			this.$rangeHeader.text(this.$rangeHeader.text()+': ');

			this.$list = $('<ul class="list-inline"></ul>');

			_.each(links, function(v){
				this.$list.append(v);
			}, this);
			$container.append([ this.$rangeHeader, this.$list ]);
		} else {
			$container.append( this.$rangeHeader );
		}
		this.$el.append($container).removeClass('hidden');
		return this;
	},
	/**
	 * remove all limiters (including query)
	 * @param {Object} e click event object
	 */
	removeAll: function(e) {
		e.preventDefault();
		this.model.removeAllFacets(true);
	}

});


//!AZFacetView
var AZFacetView = FacetView.extend(
/** @lends AZFacetView.prototype */
{

	/**
	 * Different events for this facet type
	 */
	events: {
		'change select': 'toggleFacet'
	},
	initialize: function(options) {
		if (options.facetType) {
			this.facetType = options.facetType;
		}
		this.listenTo(this.model, 'search:retrieve search:noresults', this.makeList);
		this.render();
	},
	/**
	 * create the display
	 */
	render: function() {
		this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }

		this.$el.html('');

		var $label = jQuery('<label></label>').addClass('sr-only').attr('for', 's-srch-'+this.model.get('id')+'-facet-'+this.facetType).html( this.model.get('lang')['az_dropdown_'+this.facetType] );

		this.$select = jQuery('<select></select>').attr({
			'id': 's-srch-'+this.model.get('id')+'-facet-'+this.facetType,
			'class': 'form-control',
			'name': this.facetType,
			'aria-controls': 's-srch-results-'+this.model.get('id')
		});

		var $div = jQuery('<div></div>').addClass('col-sm-4 form-group').append([$label, this.$select]);

		this.$el.append($div);

		return this;
	},
	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		this.$select.empty();

		var facetData = this.model.get('facet_results');
		var curFacets = this.model.get('facets')[this.facetType];
		var list = [];

		list.push($('<option></option>').text(this.model.get('lang')['srch_filters_az_'+this.facetType]).attr('value', ''));

		//new array so we can sort the facets alphabetically
		var facet_names = _.keys(facetData[this.facetType]).sort();
		_.each(facet_names, function(v,k) {

			var checked = (this.facetSelected(v)) ? 'selected' : '';
			var $option = $('<option></option>').text(v.capitalize()).attr('value', v).prop('selected', checked);
			list.push($option);
		}, this);

		if (list.length == 0) {
			this.$select.append('<option>'+this.model.get('lang').srch_facetnone+'</option>');
		} else {
			_.each(list, function(v){
				this.$select.append(v);
			}, this);
		}
	},
	/**
	 * Apply facet via select change event
	 */
	toggleFacet: function(e) {
		if ($(e.currentTarget).val() == '') {
			this.model.removeFacet(this.facetType);
		} else {
			this.model.setFacet(this.facetType, $(e.currentTarget).val(), false);
		}
	},

});


//!AZBrowseView
var AZBrowseView = Backbone.View.extend(
/** @lends AZBrowseView.prototype */
{

	/**
	 * Different events for this facet type
	 */
	events: {
		'click a[data-letter]': 'browseAlpha'
	},

	initialize: function(options) {
		if (options.facetType) {
			this.facetType = options.facetType;
		}
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.updateLetter);
		this.listenTo(this.model, 'search:retrieve search:noresults', this.updateLinks);
	},
	/**
	 * create the display
	 */
	render: function() {

		this.$el.html('');

		var $label = jQuery('<h3></h3>').addClass('sr-only').attr('id', 's-srch-'+this.model.get('id')+'-facet-'+this.facetType).html( this.model.get('lang')['az_browse_name'] );

		this.$list = jQuery('<ol></ol>').attr({
			'class': 'list-unstyled list-inline',
			'aria-labelledby': 's-srch-'+this.model.get('id')+'-facet-'+this.facetType
		});

		var links = [
			$('<li></li>').append( $('<a></a>').html( this.model.get('lang').az_filter_all ).attr({ href: '#', 'data-letter': '', 'aria-controls': 's-srch-results-'+this.model.get('id') }) )
		];

		var alphabet = "abcdefghijklmnopqrstuvwxyz#".split("");
		_.each(alphabet, function(letter) {

			  links.push( $('<li></li>').append( $('<a></a>').html(letter.toUpperCase()).attr({ href: '#', 'data-letter': letter, 'aria-controls': 's-srch-results-'+this.model.get('id') }) ) )

		}, this);

		this.$list.append(links);

		var $div = jQuery('<div></div>').addClass('col-sm-12 s-srch-alphabrowse').attr('id', 's-srch-'+this.model.get('id')+'-alphabrowse').append([$label, this.$list]);

		this.$el.append($div);

		return this;
	},
	/**
	 * Update the currently selected (bolded) letter
	 */
	updateLetter: function() {
		var curLetter = this.model.get('alphaLetter');
		this.$list.find('a').removeClass('current');
		this.$list.find('a[data-letter="'+curLetter+'"]').addClass('current');
	},
	/**
	 * Update the inactive letters for current results
	 */
	updateLinks: function() {
		searchcontroller.debug('updateLinks');
		var facetData = this.model.get('facet_results')._n;

		this.$list.find('a').each(function(i,el){
			var $link = $(el);
			$link.removeClass('inactive');
			var linkletter = $link.attr('data-letter');
			if (linkletter !== '' && facetData && !facetData[linkletter]) {
				$link.addClass('inactive');
			}

		});

	},
	/**
	 * Browse by letter
	 * @param {Object} e event object for click
	 */
	browseAlpha: function(e) {
		e.preventDefault();
		var $link = $(e.currentTarget);
		if ($link.hasClass('inactive')) { return; }
		var letter = $link.attr('data-letter');

		if (letter == '') {
			this.model.removeFacet('_n');
			return;
		}

		this.model.setFacet('_n', letter, false);
	},

});
